module.exports = __webpack_public_path__ + "img/close-square.99ce3cad.svg";